import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	IRequestClientDoubleFactor,
	IRequestSendEmail,
	IResponseClientDoubleFactor,
	IResponseSendEmail
} from '@pacifico/interfaces/shared-api.interface';
import { Observable } from 'rxjs';
import { IResponse } from '../endpoint-api';
import { EndPointApiService } from '../endpoint-api.service';

@Injectable({ providedIn: 'root' })
export class SharedApiService {
	constructor(private _httpClient: HttpClient, private _endPointApiService: EndPointApiService) {}

	sendEmail(data: IRequestSendEmail): Observable<IResponse<IResponseSendEmail>> {
		return this._httpClient.post<IResponse<IResponseSendEmail>>(this._endPointApiService.SHARED.email, data);
	}

	clientDoubleFactor(data: IRequestClientDoubleFactor): Observable<IResponse<IResponseClientDoubleFactor>> {
		return this._httpClient.post<IResponse<IResponseClientDoubleFactor>>(
			this._endPointApiService.SHARED.client2F,
			data
		);
	}
}
